import { SystemStatusBtnView } from './SystemStatusBtn.view';

export const SystemStatusBtn = SystemStatusBtnView;
